import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23f44468"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "event-page" }
const _hoisted_2 = {
  key: 0,
  class: "event-state"
}
const _hoisted_3 = {
  key: 1,
  class: "event-state event-state--empty"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-calendar-x" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Nenhum evento disponível", -1))
const _hoisted_6 = { class: "event-hero" }
const _hoisted_7 = { class: "event-shell" }
const _hoisted_8 = { class: "event-nav" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "event-image-wrap" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "event-copy" }
const _hoisted_13 = {
  key: 0,
  class: "event-eyebrow"
}
const _hoisted_14 = { class: "event-highlights" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Data do evento", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Investimento", -1))
const _hoisted_17 = { class: "event-highlight-wide" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Local do evento", -1))
const _hoisted_19 = { class: "event-content" }
const _hoisted_20 = { class: "event-shell event-content-grid" }
const _hoisted_21 = {
  key: 0,
  class: "event-eyebrow"
}
const _hoisted_22 = {
  key: 1,
  class: "event-benefits"
}
const _hoisted_23 = { class: "event-cta-card" }
const _hoisted_24 = { class: "event-eyebrow" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  class: "event-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "event-modal-title"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-x" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  class: "event-modal-progress",
  "aria-label": "Progresso da inscrição"
}
const _hoisted_32 = { class: "event-modal-header" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "event-eyebrow" }, "Inscrição", -1))
const _hoisted_34 = { id: "event-modal-title" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Conte um pouco sobre você para garantir sua participação.", -1))
const _hoisted_36 = {
  key: 0,
  class: "event-alert event-alert--error",
  role: "alert"
}
const _hoisted_37 = { class: "event-form-grid" }
const _hoisted_38 = { class: "event-field event-field--wide" }
const _hoisted_39 = { class: "event-field" }
const _hoisted_40 = { class: "event-field" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Selecione uma opção", -1))
const _hoisted_42 = ["value"]
const _hoisted_43 = {
  key: 0,
  class: "event-field"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Selecione uma opção", -1))
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "event-field event-field--wide" }
const _hoisted_47 = {
  key: 1,
  class: "event-field event-field--wide"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Selecione uma opção", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "now" }, "Pagar agora via Pix", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "event_day" }, "Pagar no dia do evento", -1))
const _hoisted_51 = [
  _hoisted_48,
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = ["disabled"]
const _hoisted_53 = {
  key: 1,
  class: "event-payment-step"
}
const _hoisted_54 = { class: "event-modal-header" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "event-eyebrow" }, "Pagamento via Pix", -1))
const _hoisted_56 = { id: "event-modal-title" }
const _hoisted_57 = { class: "event-pix-card" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Valor", -1))
const _hoisted_59 = { class: "event-pix-price" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-copy" }, null, -1))
const _hoisted_61 = ["href"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-whatsapp-logo" }, null, -1))
const _hoisted_63 = {
  key: 2,
  class: "event-success-step"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-check-circle" }, null, -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "event-modal-title" }, "Inscrição realizada!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando evento..."))
      : (!_ctx.event)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("p", null, _toDisplayString(_ctx.loadError || "Ainda não há um evento ativo. Volte em breve para conferir as novidades."), 1)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("section", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("nav", _hoisted_8, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatEventDate(_ctx.event.starts_at, _ctx.event.ends_at)), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "event-primary-action",
                    disabled: !_ctx.event.registrations_are_open,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openRegistrationModal && _ctx.openRegistrationModal(...args)))
                  }, _toDisplayString(_ctx.event.registrations_are_open ? "Inscrever-se" : "Inscrições encerradas"), 9, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("img", {
                    src: _ctx.eventImage,
                    alt: _ctx.event.title,
                    class: "event-image"
                  }, null, 8, _hoisted_11)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.event.eyebrow)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.event.eyebrow), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("h1", null, _toDisplayString(_ctx.event.title), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.event.hero_text), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatEventDate(_ctx.event.starts_at, _ctx.event.ends_at)), 1),
                      _hoisted_15
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.event.is_free ? "Gratuito" : _ctx.formatCurrency(_ctx.event.price)), 1),
                      _hoisted_16
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.event.address), 1),
                      _hoisted_18
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.event.registrations_are_open ? "Inscrições abertas" : "Inscrições encerradas"), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.registrationDeadlineLabel), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", null, [
                  (_ctx.event.content_eyebrow)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.event.content_eyebrow), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("h2", null, _toDisplayString(_ctx.event.content_title), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.event.content_text), 1),
                  (_ctx.event.benefits?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event.benefits, (benefit, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: benefit }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(_ctx.benefitIcons[index] || 'ph ph-check-circle')
                            }, null, 2),
                            _createElementVNode("span", null, _toDisplayString(benefit), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("aside", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.event.title), 1),
                  _createElementVNode("h2", null, _toDisplayString(_ctx.event.registrations_are_open ? "Garanta sua participação" : "Inscrições encerradas"), 1),
                  (_ctx.event.registrations_are_open)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_25, " Preencha seus dados em poucos passos. Você não sairá desta página. "))
                    : (_openBlock(), _createElementBlock("p", _hoisted_26, "Este evento continua disponível para consulta, mas não recebe novas inscrições.")),
                  _createElementVNode("button", {
                    type: "button",
                    class: "event-primary-action event-primary-action--wide",
                    disabled: !_ctx.event.registrations_are_open,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openRegistrationModal && _ctx.openRegistrationModal(...args)))
                  }, _toDisplayString(_ctx.event.registrations_are_open ? "Fazer inscrição" : "Período encerrado"), 9, _hoisted_27)
                ])
              ])
            ])
          ], 64)),
    (_ctx.modalOpen && _ctx.event)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "event-modal-backdrop",
          role: "presentation",
          onClick: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeRegistrationModal && _ctx.closeRegistrationModal(...args)), ["self"]))
        }, [
          _createElementVNode("section", _hoisted_28, [
            _createElementVNode("button", {
              ref: "closeButton",
              type: "button",
              class: "event-modal-close",
              "aria-label": "Fechar",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeRegistrationModal && _ctx.closeRegistrationModal(...args)))
            }, _hoisted_30, 512),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("span", {
                class: _normalizeClass({ active: _ctx.modalStep === 'form' })
              }, "1. Informações pessoais", 2),
              (!_ctx.event.is_free)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass({ active: _ctx.modalStep === 'payment' })
                  }, "2. Pagamento", 2))
                : _createCommentVNode("", true)
            ]),
            (_ctx.modalStep === 'form')
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitRegistration && _ctx.submitRegistration(...args)), ["prevent"]))
                }, [
                  _createElementVNode("header", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("h2", _hoisted_34, _toDisplayString(_ctx.event.title), 1),
                    _hoisted_35
                  ]),
                  (_ctx.formError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.formError), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("label", _hoisted_38, [
                      _createTextVNode(" Nome completo "),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.name) = $event)),
                        required: "",
                        maxlength: "255",
                        type: "text",
                        autocomplete: "name"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.form.name,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_39, [
                      _createTextVNode(" E-mail "),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.email) = $event)),
                        required: "",
                        maxlength: "255",
                        type: "email",
                        autocomplete: "email"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.form.email,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_40, [
                      _createTextVNode(" Celular (WhatsApp) "),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.whatsapp) = $event)),
                        required: "",
                        maxlength: "15",
                        type: "tel",
                        inputmode: "numeric",
                        autocomplete: "tel",
                        onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.formatWhatsapp && _ctx.formatWhatsapp(...args)))
                      }, null, 544), [
                        [
                          _vModelText,
                          _ctx.form.whatsapp,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", {
                      class: _normalizeClass(["event-field", { 'event-field--wide': _ctx.event.show_videira_relationship === false }])
                    }, [
                      _createTextVNode(" Qual célula você pertence atualmente? "),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.cell_name) = $event)),
                        required: ""
                      }, [
                        _hoisted_41,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cellOptions, (cell) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: cell,
                            value: cell
                          }, _toDisplayString(cell), 9, _hoisted_42))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.form.cell_name]
                      ])
                    ], 2),
                    (_ctx.event.show_videira_relationship !== false)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_43, [
                          _createTextVNode(" Você conhece a Videira? "),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.videira_relationship) = $event)),
                            required: ""
                          }, [
                            _hoisted_44,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relationshipOptions, (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: option,
                                value: option
                              }, _toDisplayString(option), 9, _hoisted_45))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.form.videira_relationship]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("label", _hoisted_46, [
                      _createTextVNode(" Qual é a sua expectativa para esse evento? "),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.expectation) = $event)),
                        required: "",
                        maxlength: "2000",
                        rows: "4"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.form.expectation,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    (!_ctx.event.is_free && _ctx.event.allows_payment_on_event_day)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_47, [
                          _createTextVNode(" Quando você deseja realizar o pagamento? "),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.payment_timing) = $event)),
                            required: ""
                          }, _hoisted_51, 512), [
                            [_vModelSelect, _ctx.form.payment_timing]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("button", {
                    class: "event-primary-action event-primary-action--wide",
                    type: "submit",
                    disabled: _ctx.isSubmitting
                  }, _toDisplayString(_ctx.registrationActionLabel), 9, _hoisted_52),
                  (!_ctx.event.is_free)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "event-link-action",
                        type: "button",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.modalStep = 'payment'))
                      }, " Já me inscrevi / ver dados do Pix "))
                    : _createCommentVNode("", true)
                ], 32))
              : (_ctx.modalStep === 'payment')
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("header", _hoisted_54, [
                      _hoisted_55,
                      _createElementVNode("h2", _hoisted_56, _toDisplayString(_ctx.registrationCreated ? "Inscrição realizada!" : "Dados para pagamento"), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.event.payment_instructions || "Faça o Pix e envie o comprovante pelo WhatsApp."), 1)
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("strong", _hoisted_59, _toDisplayString(_ctx.formatCurrency(_ctx.event.price)), 1),
                      _createElementVNode("span", null, "Chave Pix — " + _toDisplayString(_ctx.event.pix_key_type), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.event.pix_key), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "event-copy-action",
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.copyPixKey && _ctx.copyPixKey(...args)))
                      }, [
                        _hoisted_60,
                        _createTextVNode(" " + _toDisplayString(_ctx.pixCopied ? "Copiado!" : "Copiar chave Pix"), 1)
                      ])
                    ]),
                    _createElementVNode("a", {
                      href: _ctx.whatsappLink,
                      target: "_blank",
                      rel: "noopener",
                      class: "event-whatsapp-action"
                    }, [
                      _hoisted_62,
                      _createTextVNode(" Enviar comprovante ")
                    ], 8, _hoisted_61),
                    (!_ctx.registrationCreated)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "event-link-action",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.modalStep = 'form'))
                        }, "Voltar para a inscrição"))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _hoisted_64,
                    _hoisted_65,
                    _createElementVNode("p", null, _toDisplayString(_ctx.registrationSuccessMessage || `Sua participação em ${_ctx.event.title} foi registrada com sucesso.`), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "event-primary-action event-primary-action--wide",
                      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeRegistrationModal && _ctx.closeRegistrationModal(...args)))
                    }, "Concluir")
                  ]))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}